export enum PurchaseEntryPoint {
    ByMovie = 'ByMovie',
    ByCinema = 'ByCinema',
    FasTicket = 'FasTicket',
    HallBooking = 'HallBooking',
    ByFnB = 'ByFnB',
}

export enum PasswordType {
    CURRENT_PASSWORD = 'currentPassword',
    PASSWORD = 'password',
    CONFIRM_PASSWORD = 'confirmPassword',
}

export enum SeatMappingCategory {
    TYPE = 'TYPE',
    STATUS = 'STATUS',
}

export enum SafetyGuidelinesTitleDisplay {
    PLAYPLUS = 'Play Guidelines',
    '4DX' = '4DX Safety Guidelines',
    MX4D = 'MX4D Safety Guidelines',
    EXTREME4DX = 'Extreme 4DX Safety Guidelines',
    DBOX = 'DBOX Safety Guidelines',
}

export enum SeatSelectionQueryParams {
    PARENT_ID = 'parentID',
    OPRN_DATE = 'oprndate',
    LOCATION_ID = 'locationID',
    CHILD_CODE = 'childCode',
    SHOW_ID = 'showID',
    HALL_GROUP = 'hallGroup',
}

export enum CinemaType {
    AURUM = 'AURUM',
    VELVET = 'VELVET',
}

export enum RewardsCategory {
    ALL = 'ALL',
    TICKETS = 'TICKETS',
    FNB = 'FNB',
    OTHERS = 'OTHERS',
}

export enum TokenType {
    ProdEpay = 'GSC-EPAY-PROD-2026-04-A8f29KlmQ7zXp3RtY6W1N5B2C9D4E8F',
    ProdEinvoice = 'GSC-EINV-PROD-2026-04-Z3k91LmV8XpT2R5W6Y4N7B1C9D8FQ0A2',
    DevEinvoice = 'GSC-EINV-DEV-2026-04-M4n82QpL7Xc5Z1T9R6W3B8D2F0A7K9V',
    DevEpay = 'GSC-EPAY-DEV-2026-04-H7d92PlxQ4Mz8TnX5V3L9C1K8B2D6F0A4',
}
